import {
  CrudBuilderState,
  didError,
  didSucceed,
  getFetchSlice,
  hasStarted
} from "seneca-common/utils/apiStates";

type State = CrudBuilderState;

// fetch all
function getFetchState(state: State) {
  return getFetchSlice(state);
}

export function classAssignmentsAreFetching(
  state: State,
  classId: string
): boolean {
  return hasStarted(getFetchState(state), classId);
}

export function classAssignmentsFetchSucceeded(
  state: State,
  classId: string
): boolean {
  return didSucceed(getFetchState(state), classId);
}

export function classAssignmentsFetchErrored(
  state: State,
  classId: string
): boolean {
  return didError(getFetchState(state), classId);
}

export function classAssignmentsFetchFinished(state: State, classId: string) {
  return (
    classAssignmentsFetchSucceeded(state, classId) ||
    classAssignmentsFetchErrored(state, classId)
  );
}

export function classAssignmentsNeedFetching(state: State, classId: string) {
  return !(
    classAssignmentsFetchSucceeded(state, classId) ||
    classAssignmentsAreFetching(state, classId)
  );
}
